import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import approveImage from "../../../src/assets/icons/approve-image.svg";
import rejectImage from "../../../src/assets/icons/reject-image.svg";
import "./FeedbackModal.scss";
import { Box, Typography } from "@mui/material";
import Header from "../../layout/header/Header";
import { useTranslation } from "react-i18next";
import { APPROVAL_STATUS, COMPARE_VALUE } from "../../config/constant";

const UnitApprovalThankYou = () => {
  const { t } = useTranslation("common", { keyPrefix: "approveUnitThankYou" });
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location?.search);

  const status = query.get("status")?.toLowerCase() || ''; // "approve" or "reject"
  const isApproved = status === APPROVAL_STATUS.APPROVE;
  const isRejected = status === APPROVAL_STATUS.REJECT;

  useEffect(() => {
    if (!isApproved && !isRejected) {
      history.replace("/404");
    }
  }, [isApproved, isRejected, history]);

   if (!isApproved && !isRejected) return null;

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header logo={COMPARE_VALUE?.Puravankara} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 90px)", // adjust if header height differs
          textAlign: "center",
        }}
      >
      <Box
        component="img"
        src={isApproved ? approveImage : rejectImage}
        alt={isApproved ? "approved" : "rejected"}
        sx={{
          maxWidth: "80%",
          height: "auto",
          mb: 5,
        }}
      />

      <Typography
        sx={{
          fontSize: { xs: "20px", sm: "25px" },
          fontWeight: 600,
          color: "#1C252E",
          mb: 1,
        }}
      >
        {isApproved ? t("approved") : t("rejected")}
      </Typography>

      <Typography
        sx={{
          fontSize: "18px",
          color: "#1C252E",
          lineHeight: "22px",
          maxWidth: "600px",
        }}
      >
        {isApproved
          ? t("approvedMessage")
          : t("rejectedMessage")}
      </Typography>
    </Box>
    </>
  );
};

export default UnitApprovalThankYou;
